import React from 'react';

export default function TextCollectionField({ id, labelText, field, onChange, disclaimerEl, className }) {
	if (!field?.accessionKey) {
		return null;
	}
	return (
		<div id={id} className={className + (field.valid === false ? ' has-error' : '')}>
			<label className="control-label" htmlFor={`${id}Input`}>
				{labelText}<span className="text-danger">*</span>
			</label>
			<input
				className="form-control"
				id={`${id}Input`}
				type="text"
				value={field.value}
				data-accessionkey={field.accessionKey}
				onChange={onChange}
			/>
			{field.valid === false && (
				<span className="validation-message text-danger">{field.message || 'Please fill out this field.'}</span>
			)}
			{disclaimerEl}
		</div>
	);
}
